import { useAuthUserDetails } from "@apis/users/useUsers"
import { useAccountOfferFunnel } from "./useAccountOfferFunnel"
import {
  useGetWinbackOffersQuery,
} from "@apis/winbacks/useWinbacks"
import { useGetRetentionOffersQuery } from "@apis/retention/useRetention"

export const useOffersSerializer = () => {
  const { data: userInfo } = useAuthUserDetails()
  const { offerType, account_id } = useAccountOfferFunnel()

  const getWinbackOffersQuery = useGetWinbackOffersQuery(
    account_id,
    {
      user_id: userInfo?.user_id,
    },
    offerType === "Winback",
  )

  const getRetentionOffersQuery = useGetRetentionOffersQuery(
    account_id,
    {
      user_id: userInfo?.user_id,
    },
    offerType === "Retention",
  )

  return offerType === "Retention"
    ? getRetentionOffersQuery
    : getWinbackOffersQuery
}
